import { render, staticRenderFns } from "./viewCadastroCliente.vue?vue&type=template&id=205f4ea6&scoped=true&"
import script from "./viewCadastroCliente.vue?vue&type=script&lang=js&"
export * from "./viewCadastroCliente.vue?vue&type=script&lang=js&"
import style0 from "./viewCadastroCliente.vue?vue&type=style&index=0&id=205f4ea6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f4ea6",
  null
  
)

export default component.exports